// COMBINA VARIOS SAGAS

import { all } from 'redux-saga/effects';
import auth from './auth/sagas';
import user from './user/sagas';
import notify from './notify/saga';

export default function* rootSaga() {
  return yield all([auth, user, notify]);
}
